import axios from "axios";

// Global axios response interceptor
// Automatically logs out and redirects to login when token is invalid/expired
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const message = error.response.data?.message || "";
      // Only auto-logout for token-related 401s, not login failures
      if (message.includes("Invalid or expired token") || message.includes("Access denied")) {
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("role");
        localStorage.removeItem("visibleTabs");
        localStorage.removeItem("permissions");
        localStorage.removeItem("userDetails");
        
        // Redirect to login page
        window.location.href = window.location.origin + window.location.pathname + "#/";
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
